import axios from 'axios';
import config from './config';

export const call = (token, method, route, body) => {
  return axios({
    url: config.API_URL + route,
    method,
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    data: body,
  })
    .then((response) => {
      if (process.env.NODE_ENV === 'development') {
        console.log(`API Call - method:${method}, route:${route}`);
        if (body) {
          console.log(body);
        }
        console.log('API Response 2XX ---->');
        console.log(response);
      }
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};
